import * as React from 'react';
import * as PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
import { jsx as ___EmotionJSX } from "@emotion/core";
var colour = variables.colour;
var placeholderColour = colour.neutral300;
var outerStyle = /*#__PURE__*/css("stroke:", placeholderColour, ";fill:none;stroke-width:2px;stroke-miterlimit:10;stroke-linecap:square;stroke-linejoin:round;text-align:center;.round{stroke-linecap:round;}");
var imageStyle = {
  name: "l55fnl",
  styles: "max-height:115px;"
};
var Placeholder = _ref => {
  var className = _ref.className;
  return ___EmotionJSX("div", {
    className: className,
    css: outerStyle
  }, ___EmotionJSX("svg", {
    css: imageStyle,
    viewBox: "0 0 110 48"
  }, ___EmotionJSX("circle", {
    cx: "86",
    cy: "25.6",
    r: "5.7"
  }), ___EmotionJSX("line", {
    x1: "86",
    y1: "32.6",
    x2: "86",
    y2: "44.9"
  }), ___EmotionJSX("path", {
    d: "M56.5,44.9h13.9V26.6H56.7 M40.6,26.6H26.9v18.3h13.5"
  }), ___EmotionJSX("rect", {
    x: "40.6",
    y: "19.7",
    width: "16",
    height: "25.2"
  }), ___EmotionJSX("rect", {
    x: "61.2",
    y: "31.1",
    width: "4.6",
    height: "4.6"
  }), ___EmotionJSX("rect", {
    x: "31.5",
    y: "31.1",
    width: "4.6",
    height: "4.6"
  }), ___EmotionJSX("rect", {
    x: "45.2",
    y: "31.1",
    width: "6.9",
    height: "13.8"
  }), ___EmotionJSX("polygon", {
    points: "48.6,3.7 61.2,19.7 36.1,19.7"
  }), ___EmotionJSX("g", {
    className: "round"
  }, ___EmotionJSX("polyline", {
    points: "39.5,26.6 22.4,26.6 29.2,10.5 43.3,10.5"
  }), ___EmotionJSX("polyline", {
    points: "54.1,10.5 68.1,10.5 74.9,26.6 57.8,26.6"
  }), ___EmotionJSX("line", {
    x1: "17.4",
    y1: "45.1",
    x2: "94.7",
    y2: "45.1"
  }), ___EmotionJSX("line", {
    x1: "98",
    y1: "45.2",
    x2: "101.7",
    y2: "45.2"
  }), ___EmotionJSX("line", {
    x1: "10.4",
    y1: "45.2",
    x2: "14.1",
    y2: "45.2"
  }), ___EmotionJSX("line", {
    x1: "107.4",
    y1: "45.2",
    x2: "108.3",
    y2: "45.2"
  }), ___EmotionJSX("line", {
    x1: "2.8",
    y1: "45.2",
    x2: "3.8",
    y2: "45.2"
  }))));
};
Placeholder.propTypes = {
  className: PropTypes.string
};
Placeholder.defaultProps = {
  className: undefined
};
export default Placeholder;